<template>
  <button
    class="button"
    :class="{ 'button--loading': isLoading }"
    @click.prevent="updateTracking"
    v-tooltip="{
      theme: 'tooltip-top-left',
      content: tooltip
    }"
  >
    <Component :is="icon"/>
  </button>
</template>

<script>
import BaseLoaderLite from '@/components/base/BaseLoaderLite'
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'PartialTopTermsButtonTracking',

  components: {
    BaseLoaderLite
  },

  props: {
    term: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      isLoading: false,
      isTracked: null
    }
  },

  computed: {
    ...mapState('base', ['mainApi']),

    icon () {
      return this.isLoading
        ? 'BaseLoaderLite'
        : this.isTracked ? 'SvgIconFlag' : 'SvgIconFlagOutline'
    },

    tooltip () {
      return this.isTracked
        ? 'Deixar de<br>monitorar.'
        : 'Monitorar<br>este termo.'
    }
  },

  created () {
    this.isTracked = this.term.isTracked
  },

  methods: {
    async updateTracking () {
      const { word, isTracked } = this.term
      const payload = { word }
      let url = `${this.mainApi}semantic-word-cloud/`

      this.isLoading = true

      url += isTracked ? 'remove-word' : 'add-word'

      try {
        await axios.post(url, payload)

        this.isTracked = !isTracked

        this.$root.$emit('tracking-updated', true)
      } catch (error) {
        throw error
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  display: flex;
  width: 13px;
  height: 13px;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: 0;
  background: none;

  &:hover {
    svg {
      fill: nth($colors-custom, 2);
    }
  }

  &--loading {
    pointer-events: none;
  }

  svg {
    transition: all 0.1s;
    fill: nth($colors-custom, 1);
  }
}

</style>
